import { useEffect, useState } from "preact/hooks";

/**
 * The open board's task count, kept module-level so it survives route
 * changes: the Schedules and Done tabs show the last known count too. Set by
 * the open Board every time it loads tasks (src/views/Board.tsx); read by
 * the tab bar (src/components/Shell.tsx).
 */
const EVENT = "op:open-count";

let count: number | null = null;
let revision = 0;

export function setOpenCount(n: number): void {
  revision++;
  if (count === n) return;
  count = n;
  window.dispatchEvent(new Event(EVENT));
}

/** A background refresh must not overwrite a newer board response. */
export async function refreshOpenCount(load: () => Promise<{ length: number }>, active: () => boolean): Promise<void> {
  const started = revision;
  const tasks = await load();
  if (active() && revision === started) setOpenCount(tasks.length);
}

/** Null until the open board has loaded at least once this page load. */
export function useOpenCount(): number | null {
  const [value, setValue] = useState(count);
  useEffect(() => {
    const update = () => setValue(count);
    window.addEventListener(EVENT, update);
    update();
    return () => window.removeEventListener(EVENT, update);
  }, []);
  return value;
}
